import React, { useEffect, useRef } from 'react';
import { AnimateHeartCanvas } from './animateHeartCanvas'; // Import the fixed class

const HeartAnimation = ({ containerRef }) => {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const animateHeartCanvas = new AnimateHeartCanvas(
      0,          // hMin
      10,        // hMax
      500,        // countHeart
      20,         // sizeMin
      125,        // sizeMax
      '#00000',  // bgColor
      container   // Pass the containerRef here
    );

    animateHeartCanvas.play();

    // Cleanup animation on unmount
    return () => {
      animateHeartCanvas.destroy();
    };
  }, [containerRef]);

  return null; // No JSX rendered here, canvas is handled by the class itself
};

export default HeartAnimation;
